var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"winner-page",attrs:{"id":"winner-page"}},[_c('div',{staticClass:"winner-page__content"},[_c('CodeFillingWinnerForm')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }